import { HEX_FIELD, clamp } from './fieldGeometry'
import { arrivalReveal, smoothCurve } from './arrivalMotion'

/** One continuous wave, with a displaced crest and a dissipating connected wake. */
export function hexWaveFrame(elapsed: number) {
  const progress = clamp(elapsed / 2200)
  const radius = 12 + smoothCurve(progress) * 660
  const envelope = arrivalReveal(elapsed) * (1 - smoothCurve((progress - .78) / .22))
  return HEX_FIELD.vertices.map((point) => {
    const x = point.x - 360, y = point.y - 260
    const distance = Math.hypot(x, y)
    const crest = Math.exp(-(((distance - radius) / 48) ** 2))
    const wake = clamp((radius - distance) / 44) * Math.exp(-Math.max(0, radius - distance) / 170)
    const scale = 1 + (crest * 16 + wake * 4) / Math.max(40, distance)
    const twist = crest * .025
    return {
      x: 360 + (x * Math.cos(twist) - y * Math.sin(twist)) * scale,
      y: 260 + (x * Math.sin(twist) + y * Math.cos(twist)) * scale,
      radius: 1.6 + crest * 1.6,
      opacity: envelope * (.84 * crest + .24 * wake),
      crest,
    }
  })
}
